import { BCLoading } from '@bimser/components';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import React from 'react';
import Styles from '../assets/styles.scss';
import { IWorkflowFrameCProps, IWorkflowFrameProps } from '../entities';

const WorkflowFrame: React.FC<IWorkflowFrameProps & IWorkflowFrameCProps> = props => {
	const iframeOnLoad = () => {
		props.onFrameLoaded?.();
	};

	return (
		<BCLoading
			show={props.showLoading}
			delay={500}
		>
			<iframe
				src={props.url}
				width="100%"
				height="100%"
				frameBorder="0"
				onLoad={iframeOnLoad}
				className={Styles.IframeContainer}
			/>
		</BCLoading>
	);
};

export default WorkflowFrame;
